<template>
  <v-dialog v-model='dialog' max-width='400px'>
    <v-card>
              <v-card-title >
                <span class='headline fontcolor' >{{ formTitle }}</span>
              </v-card-title>
              <v-card class="pl-7 pr-6 pt-5 pb-5" >
                <v-form
                  ref="form"
                  v-model="valid"
                >
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model='editedItem.postalCodeId'
                        :maxlength='max'
                        :rules='postalRules'
                        hint='Please enter a unique 5-digit Postal Code number.'
                        label='Postal Code*'
                        validate-on-blur
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <small color="primary">*indicates required fields</small>
                    <v-spacer></v-spacer>
                    <v-btn outlined  color='red' @click="closeDialog">
                      <v-icon >mdi-close</v-icon>Cancel
                    </v-btn>
                    <v-btn :loading='btnLoader' outlined class='fontcolor' @click="save" >
                      <v-icon >mdi-check</v-icon>Save
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-card>
  </v-dialog>
</template>

<script>
import CONSTANTS from './../../../../config/constant'

export default {
  data: () => ({
    formTitle: CONSTANTS.ADD_NEW_POSTAL_CODE,
    max: 5,
    valid: true,
    btnLoader: false,
    addPostalDialog: false,
    postalRules: [v => !!v || 'Postal Code is required Field.',
      v => {
        if (v && !/^[0-9]+$/.test(v)) {
          return 'Invalid input. Only 5-digit numeric value (0-9) is allowed!'
        } else {
          return true
        }
      }, v => {
        if (v && v.length !== 5) {
          return 'Invalid input. Only 5-digit numeric value (0-9) is allowed!'
        } else {
          return true
        }
      }],
    editedItem: {
      postalCodeId: '',
      statusId: 2
    },
    defaultForm: {
      postalCodeId: '',
      statusId: 2
    }
  }),
  props: {
    addPostalDialogProp: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    dialog () {
      return this.addPostalDialogProp
    },
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    }
  },
  methods: {
    closeDialog () {
      this.editedItem = Object.assign({}, this.defaultForm)
      this.editedIndex = -1
      this.valid = false
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.$emit('resetPostalDialog', this.addPostalDialog)
    },
    save () {
      if (this.$refs.form.validate()) {
        this.btnLoader = true
        const formData = {
          postalCode: this.editedItem.postalCodeId,
          status: Number(this.editedItem.statusId),
          userId: Number(this.userId)
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('PostalCodeModule/addPostalCodeItem', { resolve, reject, formData })
        }).then((responseData) => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = responseData.responseMessage
          this.$globalStates.notification.init_notifications = true
          this.closeDialog()
        }).catch((response) => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = response.responseMessage
          this.$globalStates.notification.init_notifications = true
        })
      }
    }
  }
}
</script>
